module.exports = __webpack_public_path__ + "img/Danger.1cb95274.svg";